// aws-config.js
const awsConfig = {
    Auth: {
      Cognito: { 
        identityPoolId: 'us-east-2:37ae3dc1-162e-427c-a43d-45c91ed081c2',
        allowGuestAccess: true
      }
    },
    Storage: {
      S3: { 
        bucket: 'telecable-images',
        region: 'us-east-2'
      }
    }
};
  
export default awsConfig;  